<div class="pop-up">

  <div class="backArrowSection">
      <ion-icon (click)="dismiss()" name="close-outline"></ion-icon>
  </div>

    <div class="content">
      <div class="title">
        {{'availableOnApp' | translate}}
      </div>
      <div class="description"> {{'onlyApp'| translate}}</div>
      <ion-button expand="block" class="button-edit-profile-share" shape="round" (click) = "downloadApp()">
          {{'downloadApp' | translate}}
      </ion-button>   
  </div>

</div>
